<template>
  <div>
    <div 
      id="modalInserirEmpresas" 
      style="display: block" 
      v-if="mostrarModalInserirEmpresas" 
      class="w3-modal w3-card card-item">
      
      <div class="w3-modal-content w3-card w3-animate-zoom card-item" @click.stop>
            
        <div data-div="empresas-disponiveis" class="w3-container card-item">
          <span 
            @click="mostrarModalInserirEmpresas = false"
            class="w3-button w3-display-topright">&times;</span>
          <h2 class="texto-vermelho titulo">Empresas Disponíveis</h2>
        </div>
          
        <thead
          data-thead="empresa-selecionando"
          class="w3-col w3-padding"
          style="margin-top: 6px;"
          :key="'empresa-selecionada' + empresa.empresa_id"
          v-for="empresa in empresas_autorizadas" 
          :class="getClasseEmpresaDisponivel(empresa.adicionado)" 
          v-on:click="adicionarRemoverEmpresa(empresa.empresa_id)">
        
          <strong class="w3-col">
            <i v-if="empresa.adicionado" class="far fa-check-square"></i>
            <i v-if="!empresa.adicionado" class="far fa-square"></i>
            &nbsp;&nbsp;
            {{empresa.empresa_id}} - {{empresa.nome_fantasia}}
            <a class="w3-hide-small">  -  {{empresa.cnpj}}</a>
          </strong>
        </thead>
          
        <footer class="w3-container conteudo-centralizado">
          <button 
            data-buttom="ok"
            class="w3-btn w3-theme" 
            id="btn-confirmar-acao" 
            style="margin-top: 10px; margin-bottom:10px"  
            v-on:click="recarregarInformacoes(true, true)"            
            >
            OK
          </button>
        </footer>

      </div>
    </div>  
  
  </div>
  
</template>

<script>
  function  retornandoEmpresasIds(empresas) {
    return empresas;
  }
  import store from '@/ambiente/store';
  import RSessao from '@/components/Rest/RSessao'
  import toastr from 'toastr';
  import Legenda from '@/components/Legendas';
  export default {
    name: 'EmpresasAutorizadas',
    components:{Legenda},
    props:{c_local_storage_empresa: ''},
    data () {
      return {
        mostrar_modal: false,
        api: process.env.API,
        empresas_autorizadas: [],
        empresa_mostrando_pedidos_bloqueados: '',
        processando: false,
        mostrarModalInserirEmpresas: false,
        
        mostrar_empresas : false

      }
    },
    
    mounted(){
      this.buscarEmpresasAutorizadas();
    },
    
    computed: {
      getEmpresasSelecionadas() {
        let contador_empresas_selecionadas = 0;
        let retorno = '';
        
        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          if (this.empresas_autorizadas[i].adicionado) {
            if (retorno != '') {
              retorno += ' / ';
            } 
            retorno += this.empresas_autorizadas[i].empresa_id + ' - ' + this.empresas_autorizadas[i].nome_fantasia;
            contador_empresas_selecionadas++;
          }
        }

        if (retorno == '') {
          return 'Nenhuma empresa foi selecionada.';
        }
        else if(contador_empresas_selecionadas == this.empresas_autorizadas.length){
          return 'Todas empresas foram selecionadas.';
        }

        else {
          return retorno;
        }
      }
    },
  
    methods: {      
      async recarregarInformacoes(definir_local_storage, fechar_modal){
        if (fechar_modal){
          this.mostrarModalInserirEmpresas = false;
        }
        
        let empresas_ids = []; 
        let empresas_gravar = [];
        
        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          if (this.empresas_autorizadas[i].adicionado) {
            empresas_ids.push(this.empresas_autorizadas[i].empresa_id);
          }

          if (definir_local_storage) {
            empresas_gravar.push(
              {
                empresa_id: this.empresas_autorizadas[i].empresa_id,
                adicionado: this.empresas_autorizadas[i].adicionado,
                nome_fantasia: this.empresas_autorizadas[i].nome_fantasia
              }
            )
          };
        }

        if (definir_local_storage) {
          await(localStorage.setItem(this.c_local_storage_empresa, JSON.stringify(empresas_gravar)))
          
        }
        this.$forceUpdate();
        this.$emit('pegarIdEmpresas', empresas_ids)
        
      },
      async definirEmpresas(buscar_local_storage){
        if ((!buscar_local_storage) || (!localStorage.getItem(this.c_local_storage_empresa))) {
          this.mostrarModalInserirEmpresas = true;
          return;
        }

        let tem_empresa_selecionada = false;
        let empresas_selecionadas = JSON.parse(localStorage.getItem(this.c_local_storage_empresa))

        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
          for (let j = 0; j < empresas_selecionadas.length; j++) {
            if (this.empresas_autorizadas[i].empresa_id == empresas_selecionadas[j].empresa_id) {
              if (empresas_selecionadas[j].adicionado) {
                tem_empresa_selecionada = true;
              }
              this.empresas_autorizadas[i].adicionado = empresas_selecionadas[j].adicionado;
              break
            }
          }
        }

        
          await (this.recarregarInformacoes(false, false));
        
      },
      
      async buscarEmpresasAutorizadas(){
        if (!RSessao.carregouSessao()) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }
        this.empresas_autorizadas = await JSON.parse(JSON.stringify(store.state.empresas_autorizadas));
        
          if (this.empresas_autorizadas && this.empresas_autorizadas.length > 0) {
            for (let i = 0; i < this.empresas_autorizadas.length; i++) {
              this.empresas_autorizadas[i].adicionado = true;
            }
          }

          this.definirEmpresas(true);
      },
      
      async adicionarRemoverEmpresa(empresa_id){
        for (let i = 0; i < this.empresas_autorizadas.length; i++) {
        
          if (this.empresas_autorizadas[i].empresa_id != empresa_id) {
            continue;
          }
          
          await (this.empresas_autorizadas[i].adicionado = !this.empresas_autorizadas[i].adicionado);
          break;
        }

        await (this.empresas_autorizadas = JSON.parse(JSON.stringify(this.empresas_autorizadas)));
      },

      getClasseEmpresaDisponivel: function(adicionado){
        if (adicionado) {
          return 'w3-theme label-clicavel';
        } else {
          return 'label-clicavel';
        }
      },
    }
  }

</script>

<style scoped>

  .switch{
    width:100px;
    height: 14px;
  }

  .slider.round {
    border-radius: 34px;
    padding-top: 1px;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    font-size: 14px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 2px;
    background-color: gray;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: #636363 1px 1px 0px 0px;
  }
  
  input:checked+.slider {
    background-color: green;
    color:white;
  }
  
  input:checked+.slider:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }
  
</style>



// WEBPACK FOOTER //
// src/components/EmpresasAutorizadas.vue